import { createRoot } from 'react-dom/client'
import { Navbar } from './Navbar'

const root = document.getElementById('nova-react-navbar')

if (root && !root.__novaReactRoot) {
  root.__novaReactRoot = createRoot(root)
  root.__novaReactRoot.render(<Navbar payload={window.novaThemeReactNavbar || {}} />)
}
